(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cherry-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      root.querySelectorAll('[data-sg-open]').forEach(function (btn) {
        if (btn.dataset.sgReady) return;
        btn.dataset.sgReady = '1';
        var d = document.getElementById('sg-' + btn.dataset.sgOpen);
        if (!d) return;
        btn.addEventListener('click', function () {
          if (typeof d.showModal === 'function') d.showModal();
        });
        d.querySelectorAll('[data-sg-close]').forEach(function (c) {
          c.addEventListener('click', function () { d.close(); });
        });
        d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
